import {
  Radio,
  TableColumns,
  TableColumnsColumnProps,
  Tag,
} from '@mercai/clever'
import { SupplierCategoriesEnum, SupplierProps } from '@/types'
import { useTranslation } from 'react-i18next'

import styles from './table-supplier.module.css'
import { formatDate } from '@/helpers'
import { TableSupplierProps } from './table-supplier.type'

export const TableSupplier = ({
  actions,
  data,
  ...props
}: TableSupplierProps) => {
  const { t } = useTranslation('componentTableSupplier')

  const supplierCategoriesObject = {
    metais: (
      <Tag variant="basic" model="outline" key="metais">
        {t('columnCategoriesMetais')}
      </Tag>
    ),
    resinas_plasticas: (
      <Tag variant="primary" model="outline" key="resinas_plasticas">
        {t('columnCategoriesResinasPlasticas')}
      </Tag>
    ),
  }

  const SupplierCategoriesColumn = ({
    categories,
  }: {
    categories?: (keyof typeof SupplierCategoriesEnum)[]
  }) => (
    <div>
      {categories
        ? categories?.map((category) => supplierCategoriesObject?.[category])
        : '-'}
    </div>
  )

  const columns: TableColumnsColumnProps<SupplierProps>[] = [
    ...(props?.onSelectRow
      ? [
          {
            title: '',
            key: 'checkbox',
            width: '3.2rem',
            render: ({ index }) => (
              <div className={styles['table-check-column']}>
                <Radio
                  value={props?.selectedRow === index}
                  onChange={() => props.onSelectRow?.(index)}
                />
              </div>
            ),
          } as TableColumnsColumnProps<SupplierProps>,
        ]
      : []),
    {
      title: t('columnName'),
      key: 'name',
      dataKey: 'name',
    },
    {
      title: t('columnPhone'),
      key: 'phone',
      dataKey: 'phone',
      width: '12rem',
    },
    {
      title: t('columnCategories'),
      key: 'categories',
      dataKey: 'categories',
      width: '10rem',
      render: ({ record }) => (
        <SupplierCategoriesColumn categories={record?.categories} />
      ),
    },
    {
      title: t('columnEmail'),
      key: 'email',
      dataKey: 'email',
      width: '21rem',
    },
    {
      title: t('columnTotalProducts'),
      key: 'totalProducts',
      dataKey: 'totalProducts',
      width: '8rem',
      render: ({ value }) => value || 0,
    },
    {
      title: t('columnForeign'),
      key: 'isForeign',
      dataKey: 'isForeign',
      width: '8rem',
      render: ({ value }) =>
        value ? t('columnForeignYes') : t('columnForeignNo'),
    },
    {
      title: t('columnCreatedAt'),
      key: 'createdAt',
      dataKey: 'createdAt',
      width: '10rem',
      render: ({ value }) => (value ? formatDate(value) : '-'),
    },
    ...(actions ? [actions] : []),
  ]
  return (
    <TableColumns<SupplierProps>
      data={data || []}
      columns={columns}
      {...props}
    />
  )
}
